<template>
<div class="d-lg-flex flex-row-fluid">

    <div class="flex-column offcanvas-mobile w-300px w-xl-325px">
        <div class="card card-custom gutter-b">
            <el-alert v-if="this.formFilter.idevent !=null" type="warning" :description="isAvailable == 0 ? 'Las inscripciones han finalizado para este evento' : 'Inscripciones disponibles para este evento.'" show-icon :closable="false"></el-alert>
            <div class="card-header border-0 py-5">
                <h3 class="card-title align-items-start flex-column">
                    <span class="card-label font-weight-bolder text-dark"> Resumen de participación </span>
                    <span class="text-muted mt-3 font-weight-bold font-size-sm"> Oficiales </span>
                </h3>
            </div>
            <el-progress type="dashboard" :percentage="sumaryTotal" class="my-6">
                <template #default="{ percentage }">
                    <span class="percentage-value">{{ percentage }}</span>
                    <span class="percentage-label">Oficiales</span>
                </template>
            </el-progress>
            <div class="mx-8 mb-6">
                <div v-for="(item, index) in sumaryOfficers" :key="index" class="">
                    <span class="text-bolder" v-text="item.name"></span>
                    <el-progress :percentage="item.total" class="mb-3">{{item.total}}</el-progress>
                </div>
            </div>
        </div>
    </div>

    <div class="flex-row-fluid ml-lg-8">
        <div class="card card-custom">
            <!--begin::Header-->
            <div class="card-header flex-wrap border">
                <h3 class="card-title align-items-start flex-column">
                    <span class="card-label font-weight-bolder font-size-h3 text-success pt-3">Acreditación de Oficiales</span>
                    <span class="text-muted mt-1 font-weight-bold font-size-sm">Administrativos y Técnicos</span>
                </h3>
                <div class="card-toolbar w-50">
                    <el-select v-model="formFilter.idevent" placeholder="Seleccione un evento" size="medium" class="w-100" @change="getData">
                        <el-option v-for="item in listEvents" :key="item.idevent" :label="item.name" :value="item.idevent"></el-option>
                    </el-select>
                </div>
            </div>
            <!--begin::Body-->
            <div class="card-body">

                <div class="row mb-6">
                    <div class="col-sm-6">
                        <div v-if="formFilter.idevent !=null && isAvailable == 1" class="btn btn-sm btn-success mr-4" @click="regOfficicer"><i class="el-icon-plus"></i> Registrar</div>
                        <div v-if="formFilter.idevent !=null && isAvailable == 1" class="btn btn-sm btn-light-primary mr-4" @click="finishRegistration">Finalizar inscripcion</div>
                        <div v-if="formFilter.idevent !=null" class="btn btn-sm btn-light-danger" @click="pdfNominal">Ficha Nominal</div>
                    </div>
                    <div class="col-sm-6">
                        <el-input v-model="search1" size="medium" placeholder="Buscar por nombre" />
                    </div>
                </div>

                <el-tabs v-model="formFilter.idgroup" type="card" @tab-click="handleTab">
                    <el-tab-pane name="1">
                        <template #label>
                            <span>Administrativos</span>
                        </template>
                        <el-alert type="info" description="Lista de oficiales a nivel de evento" show-icon :closable="false"></el-alert>

                        <el-table :data="filteredOfficers" style="width: 100%" height="600">
                            <el-table-column width="45px">
                                <template #default="scope">
                                    <span :class="'label label-'+status[scope.row.checkdoc].class+' mr-2'"></span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Documento" width="120px">
                                <template #default="scope" width="100px">
                                    <span class="text-dark-50 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{scope.row.docnumber}}</span>
                                    <span class="text-secondary font-weight-bold d-block">{{scope.row.docName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Participante" width="240px">
                                <template #default="scope">
                                    <div class="d-flex align-items-center">
                                        <div class="symbol symbol-40 symbol-light-success mr-3">
                                            <el-avatar shape="circle" size="large" fit="fill" :src="scope.row.photo"></el-avatar>
                                        </div>
                                        <div class="d-flex flex-column flex-grow-1 font-weight-bold">
                                            <div class="text-hover-primary mb-0 font-size-lg"> {{scope.row.firstname}} </div>
                                            <span class=""> {{scope.row.lastname + ' ' + scope.row.surname}}</span>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="Sexo" width="70px">
                                <template #default="scope">
                                    <span v-if="scope.row.gender=='F'" class="label font-weight-bold label-lg label-light-danger label-inline">{{scope.row.gender}}</span>
                                    <span v-else class="label font-weight-bold label-lg label-light-success label-inline">{{scope.row.gender}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Función" width="150px">
                                <template #default="scope">
                                    <span :class="'d-none label font-weight-bold label-lg ' +  className() + ' label-inline'">{{scope.row.sportName}}</span>
                                    <span class="font-weight-bold text-success">{{scope.row.funcName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Registrado" width="160px">
                                <template #default="scope">
                                    <span class="text-muted">{{scope.row.created_at}}</span>
                                </template>
                            </el-table-column>

                            <el-table-column label="Acciones" align="right">
                                <template #default="scope">
                                    <el-dropdown>
                                        <span class="el-dropdown-link">
                                            Opciones<i class="el-icon-setting el-icon--right"></i>
                                        </span>
                                        <template #dropdown>
                                            <el-dropdown-menu>
                                                <el-dropdown-item v-if="scope.row.checkdoc==0" @click="handleEdit(scope.row)"><i class="el-icon-edit"></i> Editar</el-dropdown-item>
                                                <el-dropdown-item v-if="scope.row.checkdoc==0" @click="handleDelete(scope.$index, listOfficers, scope.row)"><i class="el-icon-delete"></i> Eliminar</el-dropdown-item>
                                                <el-dropdown-item command="a"><i class="el-icon-postcard"></i> Individual</el-dropdown-item>
                                                <el-dropdown-item command="b"><i class="el-icon-tickets"></i> Carta desagravio</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </template>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane name="2">
                        <template #label>
                            <span>Técnicos</span>
                        </template>
                        <div class="row border-bottom py-4">
                            <div class="col-sm-6">
                                <el-select v-model="formFilter.idsport" placeholder="Seleccione un deporte" class="w-100" @change="getOfficers">
                                    <el-option v-for="item in listSports" :key="item.idsport" :label="item.name" :value="item.idsport">
                                        <span style="float: left">{{ item.name }}</span>
                                        <span style="float: right; color: #FFF; font-size: 13px" :class="'badge badge-' + ((item.mstatus == 'O') ? 'success' : 'danger')">{{ (item.mstatus == 'O') ? 'Inscripciones habilitadas' : 'Inscripciones finalizadas' }}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="col-sm-6">
                                <el-alert type="info" description="Lista de oficiales a nivel de disciplina deportiva" show-icon :closable="false"></el-alert>
                            </div>
                        </div>

                        <el-table :data="filteredOfficers" style="width: 100%" height="600">
                            <el-table-column width="45px">
                                <template #default="scope">
                                    <span :class="'label label-'+status[scope.row.checkdoc].class+' mr-2'"></span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Documento" width="120px">
                                <template #default="scope" width="100px">
                                    <span class="text-dark-50 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{scope.row.docnumber}}</span>
                                    <span class="text-secondary font-weight-bold d-block">{{scope.row.docName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Participante" width="240px">
                                <template #default="scope">
                                    <div class="d-flex align-items-center">
                                        <div class="symbol symbol-40 symbol-light-success mr-3">
                                            <el-avatar shape="circle" size="large" fit="fill" :src="scope.row.photo"></el-avatar>
                                        </div>
                                        <div class="d-flex flex-column flex-grow-1 font-weight-bold">
                                            <div class="text-hover-primary mb-0 font-size-lg"> {{scope.row.firstname}} </div>
                                            <span class=""> {{scope.row.lastname + ' ' + scope.row.surname}}</span>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="Sexo" width="70px">
                                <template #default="scope">
                                    <span v-if="scope.row.gender=='F'" class="label font-weight-bold label-lg label-light-danger label-inline">{{scope.row.gender}}</span>
                                    <span v-else class="label font-weight-bold label-lg label-light-success label-inline">{{scope.row.gender}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Función" width="150px">
                                <template #default="scope">
                                    <span v-if="this.formFilter.tregister == 'OT'" :class="'label font-weight-bold label-lg label-light-' +  className() + ' label-inline'">{{scope.row.sportName}}</span>
                                    <span class="font-weight-bold text-primary d-block">{{scope.row.funcName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Registrado" width="160px">
                                <template #default="scope">
                                    <span class="text-muted">{{scope.row.created_at}}</span>
                                </template>
                            </el-table-column>

                            <el-table-column label="Acciones" align="right">
                                <template #default="scope">
                                    <el-dropdown>
                                        <span class="el-dropdown-link">
                                            Opciones<i class="el-icon-setting el-icon--right"></i>
                                        </span>
                                        <template #dropdown>
                                            <el-dropdown-menu>
                                                <el-dropdown-item v-if="(scope.row.checkdoc==0 || scope.row.checkdoc==4)" @click="handleEdit(scope.row)"><i class="el-icon-edit"></i> Editar</el-dropdown-item>
                                                <el-dropdown-item v-if="(scope.row.checkdoc==0 || scope.row.checkdoc==4)" @click="handleDelete(scope.$index, listOfficers, scope.row)"><i class="el-icon-delete"></i> Eliminar</el-dropdown-item>
                                                <el-dropdown-item command="a" @click="pdfIndividual(scope.row.idacreditation)">
                                                    <i class="el-icon-postcard"></i> Individual
                                                </el-dropdown-item>
                                                <el-dropdown-item command="b" @click="pdfDesagravio(scope.row.idacreditation)">
                                                    <i class="el-icon-tickets"></i> Carta desagravio
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </template>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>

    <!--start save modal-->
    <el-dialog custom-class="mdnew" v-model="modalNew" :title="'Registrar ' + title" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false" width="60%" top="3vh">
        <el-steps :active="currentstep" finish-status="success" align-center>
            <el-step description="Datos personales"></el-step>
            <el-step description="Fotografia"></el-step>
            <el-step description="Datos de acreditación"></el-step>
            <el-step description="Documentación"></el-step>
        </el-steps>
        <div class="steps">
            <PesonalInformation v-if="currentstep==0"></PesonalInformation>
            <PhotoManager v-if="currentstep==1"></PhotoManager>
            <CompetitionInformation v-if="currentstep==2"></CompetitionInformation>
            <Documentation v-if="currentstep==3"></Documentation>
        </div>
    </el-dialog>
    <!--start edit modal-->
    <el-dialog v-model="modalEdit" custom-class="mdedit" :title="'Editar acreditación ' + title" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false" width="60%" top="3vh">
        <el-tabs v-if="modalEdit">
            <el-tab-pane label="Datos personales">
                <PesonalInformation :athletedata="athleteEdit"></PesonalInformation>
            </el-tab-pane>
            <el-tab-pane label="Fotografia">
                <PhotoManager :photoData="photoEdit"></PhotoManager>
            </el-tab-pane>
            <el-tab-pane label="Datos de acreditación">
                <CompetitionInformation :academicdata="academEdit"></CompetitionInformation>
            </el-tab-pane>
            <el-tab-pane label="Documentación">
                <Documentation :academicdata="academEdit"></Documentation>
            </el-tab-pane>
        </el-tabs>
    </el-dialog>

</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import dataJson from "@/data/common";
import {
    STEP,
    MODAL_NEW,
    MODAL_EDIT
} from "@/store/step.module";
import {
    UBIGEO,
    ACREDITATION,
    OFFICERS_LIST,
    EDIT_ACREDITATION
} from "@/store/acreditation.module";
import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";
import code from "@/core/config/status.code";

//components
import PesonalInformation from "@/views/pages/steps/athletes/PersonalInformation";
import PhotoManager from "@/components/PhotoManager";
import CompetitionInformation from "@/views/pages/steps/officers/CompetitionInformation";
import Documentation from "@/views/pages/steps/athletes/Documentation";

//services
import {
    UniService,
    AuthenticationError
} from '@/core/services/uni.service';
import {
    acrService,
    acrError
} from '@/core/services/acr.service';

export default {
    name: 'official',
    components: {
        PesonalInformation,
        PhotoManager,
        CompetitionInformation,
        Documentation
    },
    data: () => ({
        formFilter: {
            idgroup: "1",
            idevent: null,
            idsport: null,
            tregister: 'OA'
        },
        title: '',
        search1: '',
        listEvents: [],
        listSports: [],
        listOfficers: [],
        sumOfficers: [],
        total: 0,
        status: dataJson.statusacrd,
        athleteEdit: {},
        photoEdit: {},
        academEdit: {},
        isAvailable: {},
        uni: null,
        labelsStatus: dataJson.colorStatus
    }),

    computed: {
        ...mapGetters(['currentstep', 'modalNew', 'modalEdit', 'currentDataOfficers']),
        filteredOfficers: function () {
            this.listOfficers = this.currentDataOfficers.data;
            //return this.listOfficers;
            return this.listOfficers.filter(data => !this.search1 || data.firstname.toLowerCase().includes(this.search1.toLowerCase()))
        },
        sumaryTotal: function () {
            this.total = 0;
            for (let index = 0; index < this.sumOfficers.length; index++) {
                this.total += parseInt(this.sumOfficers[index].total);
            }
            return this.total;
        },
        sumaryOfficers: function () {
            return this.sumOfficers = this.currentDataOfficers.sumary;
        }
    },
    methods: {
        className() {
            let index = parseInt(Math.floor(Math.random() * 7));
            return this.labelsStatus[index].class;
        },
        getOfficers() {
            try {
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                this.$store.dispatch(OFFICERS_LIST, this.formFilter)
                    .then(() => {
                        this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                    })
                    .catch((err) => {
                        this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                        this.$alert(err.data != '' ? err.data.messages.error : err.statusText, 'Error  ' + err.status, {
                            type: 'warning',
                            confirmButtonText: 'Entendido',
                            callback: action => {
                                code.Manager(err.status, 'athlete');
                            }
                        });
                    })
            } catch (error) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                this.$notify.error({
                    title: 'Error:',
                    message: error
                });
            }
        },
        async getEvents() {
            try {
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                const res = await UniService.Events();
                this.listEvents = res.data.events;
                this.uni = res.data.uni;
                const ubigeo = await UniService.Ubigeo();
                this.$store.dispatch(UBIGEO, ubigeo.data);

                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof AuthenticationError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        async getData() {
            try {
                //buscando detalles del evento
                let filter = this.listEvents.filter(data => {
                    return data.idevent.includes(this.formFilter.idevent)
                });
                this.isAvailable = (filter.length > 0) ? filter[0].register : 0;

                if (this.formFilter.idgroup === '1') {
                    this.getOfficers();
                }

                if (this.formFilter.idgroup === '2') {
                    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                    const res = await UniService.Sports(this.formFilter.idevent);
                    this.listSports = res.data;
                    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                }
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof AuthenticationError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        async regOfficicer() {
            if (this.formFilter.idevent == null)
                return this.$notify.error({
                    title: 'Campos vacios',
                    message: 'Falta seleccionar un evento para registrar un oficial'
                });

            if (this.formFilter.idgroup == "2" && this.formFilter.idsport == null)
                return this.$notify.error({
                    title: 'Campos vacios',
                    message: 'Falta seleccionar un deporte para registrar un oficial técnico'
                });

            try {
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                const res = await acrService.status(this.formFilter);
                this.$store.dispatch(ACREDITATION, this.formFilter);
                this.$store.dispatch(STEP, 0).then(() => {
                    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                    this.$store.dispatch(MODAL_NEW, true);
                });
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof acrError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        async handleEdit(a) {
            try {
                this.title = 'para ' + a.firstname;
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                this.$store.dispatch(ACREDITATION, this.formFilter);
                this.idacreditation = a.idacreditation;
                const res = await acrService.edit(a.idacreditation);
                this.athleteEdit = res.data.athlete;
                this.photoEdit = res.data.photo;
                this.academEdit = res.data.acrd;
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                this.$store.dispatch(MODAL_EDIT, true);

            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof acrError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        async handleDelete(index, rows, a) {
            try {
                const result = await this.$confirm('Esto eliminará permanentemente el registro. ¿Continuar?', 'Eliminar participación de ' + a.firstname, {
                    confirmButtonText: 'SI',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                });
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                const res = await acrService.delete(window.btoa(a.idacreditation));
                rows.splice(index, 1);
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                this.$message({
                    type: 'success',
                    message: 'Acreditación de ' + a.firstname + ' eliminada correctamente.'
                });
                this.getOfficers();
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof acrError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        handleTab() {
            this.currentDataOfficers.data = [];
            if (this.formFilter.idgroup === '1' && this.formFilter.idevent != null) {
                this.formFilter.tregister = 'OA';
                //cargo oficiales administrativos
                this.getOfficers();
            }
            if (this.formFilter.idgroup === '2' && this.formFilter.idevent != null) {
                this.formFilter.tregister = 'OT';
                //cargo disciplinas asociadas
                this.formFilter.idsport = null;
                this.getData();
            }
            this.title = (this.formFilter.idgroup === '1') ? 'Oficial Administrativo' : 'Oficial Técnico';
        },
        pdfNominal() {
            if (this.formFilter.idgroup === '1')
                window.open(process.env.VUE_APP_URL_BACKEND + `pdf/nominal?a=${window.btoa(this.formFilter.idevent)}&b=${window.btoa(18)}&c=${this.uni}&d=OA`, '_blank');
            else if (this.formFilter.idgroup === '2' && this.formFilter.idsport != null)
                window.open(process.env.VUE_APP_URL_BACKEND + `pdf/nominal?a=${window.btoa(this.formFilter.idevent)}&b=${window.btoa(this.formFilter.idsport)}&c=${this.uni}&d=OT`, '_blank');
            else
                this.$notify.error({
                    title: 'Campos vacios',
                    message: 'Falta seleccionar un deporte para descargar la ficha nominal'
                });
        },
         pdfIndividual(a) {
            window.open(process.env.VUE_APP_URL_BACKEND + `pdf/ficha-individual/${window.btoa(a)}`, '_blank');
        },
        pdfDesagravio(a) {
            window.open(process.env.VUE_APP_URL_BACKEND + `pdf/carta-desagravio/${window.btoa(a)}`, '_blank');
        },
        async finishRegistration() {
            /*try {
                const result = await this.$confirm(dataJson.textFinalice, dataJson.titleFinalice,{
                                confirmButtonText: 'SI',
                                cancelButtonText: 'Cancelar',
                                });
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                const res = await acrService.finish(this.currentAcreditation);
                this.responseFinish = res.data.message;
                //this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                this.$store.dispatch(LIST_ACREDITATION,{sport: 'ajedrez', data: this.currentAcreditation})
                .then(() => {
                    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                    this.dialogFinish = true;
                })
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof acrError) {
                    this.$alert( e.message.data !='' ? e.message.data.messages.error : e.message.statusText, 'Error ' +  e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }*/
        }
        // window.open(process.env.VUE_APP_URL_BACKEND + `pdf/nominal?a=${window.btoa(this.formFilter.idevent)}&b=${this.allConfig.report.b}&c=${this.uni}`, '_blank');},
    },
    created() {
        this.currentDataOfficers.data = [];
        this.getEvents();
    }
}
</script>

<style>
.mdnew .el-dialog__body,
.mdedit .el-dialog__body {
    padding: 5px 20px 15px 20px !important
}

.el-progress--circle,
.el-progress--dashboard {
    margin: 0px auto;
}

.el-progress .percentage-value {
    display: block;
    margin-top: 10px;
    font-size: 28px;
}

.el-progress .percentage-label {
    display: block;
    margin-top: 10px;
    font-size: 12px;
}
</style>
